import { render, staticRenderFns } from "./NeighScroller.vue?vue&type=template&id=18af1677&scoped=true"
import script from "./NeighScroller.vue?vue&type=script&lang=js"
export * from "./NeighScroller.vue?vue&type=script&lang=js"
import style0 from "./NeighScroller.vue?vue&type=style&index=0&id=18af1677&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18af1677",
  null
  
)

export default component.exports